<template>
  <a
    class="finwell-banner"
    :href="FINWELL_URL"
    target="_blank"
    rel="noopener noreferrer"
    :aria-label="`${$t('finWellBanner.copy')} — ${$t('finWellBanner.cta')}`"
    @click="postAnalyticsEvent({ intent: 'open_finwell_event', task: 'finwell_promo', action: 'click' })"
  >
    <span class="finwell-banner__copy">{{ $t('finWellBanner.copy') }}</span>
    <span class="finwell-banner__divider" aria-hidden="true"></span>
    <span class="finwell-banner__cta">{{ $t('finWellBanner.cta') }}</span>
  </a>
</template>

<script>
import { onBeforeMount } from 'vue';
import useAnalytics from '@/state/composables/useAnalytics';

// Marketing landing page for FinWell '26. UTM params are tracked by marketing - keep verbatim.
const FINWELL_URL =
  'https://stream.co/en-us/us-financial-wellbeing-26-event?utm_campaign=45836093-%5BUS%5D%20Finwell%2026%20Campaign&utm_source=Employer%20Platform%20Banner';

export default {
  name: 'FinWellBanner',
  setup() {
    const { postAnalyticsEvent } = useAnalytics();

    // Impression: only fires when the banner actually mounts (parent gates on isUsCompany).
    onBeforeMount(() => {
      postAnalyticsEvent({ intent: 'view_finwell_banner', task: 'finwell_promo', action: 'view' });
    });

    return { FINWELL_URL, postAnalyticsEvent };
  },
};
</script>

<style scoped lang="scss">
.finwell-banner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem 1rem;
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: var(--palette-color-core-1-lighten-70);
  color: var(--palette-color-default);
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-decoration: none;

  &:hover,
  &:focus {
    color: var(--palette-color-default);
    text-decoration: none;
    background-color: var(--palette-color-core-1-lighten-60);
  }
}

.finwell-banner__copy {
  color: var(--palette-color-default);
}

.finwell-banner__divider {
  flex: none;
  width: 1px;
  height: 1.25rem; /* 20px, matches Figma divider + text line-height */
  background-color: var(--palette-color-default);
}

.finwell-banner__cta {
  color: var(--palette-color-core-1);
  font-weight: 700;
  text-decoration: underline;
  white-space: nowrap;

  .finwell-banner:hover & {
    text-decoration: none;
  }
}
</style>
